







import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import * as service from '../../subjects/loader';
import { env } from '@/settings/env';

@Component
export default class UiAmbientIndicator extends Vue {
  public ambientName: string;
  public isDev: boolean = env === 'DEV';

  public beforeMount(): void {
    const ambientNameList = {
      DEV: 'DEV',
      HML: 'HML',
      TRAIN: 'TRN',
    };

    this.ambientName = ambientNameList[env];
  }

  public shouldShowEnvBar(): boolean {
    return env !== 'PRD';
  }
}
